// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../lastDayOfQuarter/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var lastDayOfQuarterWithOptions = convertToFP(fn, 2);
export default lastDayOfQuarterWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/lastDayOfQuarterWithOptions/index.js
// module id = 953
// module chunks = 0